import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import BhStory from "../../../components/BhStory";
import Awards from "../../../components/Awards";
import HomeForm from "../../../components/HomeForm";
import Testimonials from "../../../components/Testimonials";

import "../style.css";

export default function NorthVancouver() {
  const location = useLocation();

  // SEO Optimization - Meta Tag changes
  useEffect(() => {
    // Scroll to top on page load
    window.scrollTo(0, 0);

    // Canonical URL
    const canonicalUrl = `https://bur-han.ca${location.pathname}`;
    let linkTag = document.querySelector('link[rel="canonical"]');
    if (linkTag) {
      linkTag.setAttribute("href", canonicalUrl);
    } else {
      linkTag = document.createElement("link");
      linkTag.setAttribute("rel", "canonical");
      linkTag.setAttribute("href", canonicalUrl);
      document.head.appendChild(linkTag);
    }

    // TITLE - Optimized for "Landscaping North Vancouver" (Service + Location format)
    const newTitle = "Landscaping North Vancouver | Top Rated Since 1995 | BUR-HAN";
    document.title = newTitle;

    // META DESCRIPTION - Compelling with keywords and call-to-action
    const newDescription = "Best landscaping North Vancouver trust BUR-HAN. Expert lawn care, hardscaping & garden maintenance. 30+ years serving North Vancouver & Metro Vancouver. Get a quote: 604-983-2687";
    let descriptionMetaTag = document.querySelector('meta[name="description"]');
    if (descriptionMetaTag) {
      descriptionMetaTag.setAttribute("content", newDescription);
    } else {
      descriptionMetaTag = document.createElement("meta");
      descriptionMetaTag.setAttribute("name", "description");
      descriptionMetaTag.setAttribute("content", newDescription);
      document.head.appendChild(descriptionMetaTag);
    }

    // KEYWORDS - Comprehensive North Vancouver-specific keywords
    const newKeywords = [
      "landscaping North Vancouver",
      "landscaping near me North Vancouver",
      "lawn care North Vancouver",
      "lawn mowing North Vancouver",
      "lawn aeration North Vancouver",
      "lawn fertilizing North Vancouver",
      "garden maintenance North Vancouver",
      "property maintenance North Vancouver",
      "commercial landscaping North Vancouver",
      "hardscaping North Vancouver",
      "garden design North Vancouver",
      "snow removal North Vancouver",
      "chafer beetle control North Vancouver",
      "landscape maintenance North Vancouver",
      "residential landscaping North Vancouver"
    ].join(", ");
    
    let keywordsMetaTag = document.querySelector('meta[name="keywords"]');
    if (keywordsMetaTag) {
      keywordsMetaTag.setAttribute("content", newKeywords);
    } else {
      keywordsMetaTag = document.createElement("meta");
      keywordsMetaTag.setAttribute("name", "keywords");
      keywordsMetaTag.setAttribute("content", newKeywords);
      document.head.appendChild(keywordsMetaTag);
    }

    // GEO META TAGS - North Vancouver specific
    const geoLocation = document.querySelector('meta[name="geo.placename"]');
    if (geoLocation) {
      geoLocation.setAttribute("content", "North Vancouver, British Columbia");
    } else {
      const newGeoTag = document.createElement("meta");
      newGeoTag.setAttribute("name", "geo.placename");
      newGeoTag.setAttribute("content", "North Vancouver, British Columbia");
      document.head.appendChild(newGeoTag);
    }

    // OPEN GRAPH TAGS - For social media sharing
    let ogTitleTag = document.querySelector('meta[property="og:title"]');
    if (ogTitleTag) {
      ogTitleTag.setAttribute("content", newTitle);
    } else {
      ogTitleTag = document.createElement("meta");
      ogTitleTag.setAttribute("property", "og:title");
      ogTitleTag.setAttribute("content", newTitle);
      document.head.appendChild(ogTitleTag);
    }

    let ogDescriptionTag = document.querySelector('meta[property="og:description"]');
    if (ogDescriptionTag) {
      ogDescriptionTag.setAttribute("content", newDescription);
    } else {
      ogDescriptionTag = document.createElement("meta");
      ogDescriptionTag.setAttribute("property", "og:description");
      ogDescriptionTag.setAttribute("content", newDescription);
      document.head.appendChild(ogDescriptionTag);
    }

    // OG URL
    let ogUrlTag = document.querySelector('meta[property="og:url"]');
    if (ogUrlTag) {
      ogUrlTag.setAttribute("content", canonicalUrl);
    } else {
      ogUrlTag = document.createElement("meta");
      ogUrlTag.setAttribute("property", "og:url");
      ogUrlTag.setAttribute("content", canonicalUrl);
      document.head.appendChild(ogUrlTag);
    }

    // OG Type
    let ogTypeTag = document.querySelector('meta[property="og:type"]');
    if (!ogTypeTag) {
      ogTypeTag = document.createElement("meta");
      ogTypeTag.setAttribute("property", "og:type");
      ogTypeTag.setAttribute("content", "website");
      document.head.appendChild(ogTypeTag);
    }

    // TWITTER CARDS
    let twitterCard = document.querySelector('meta[name="twitter:card"]');
    if (!twitterCard) {
      twitterCard = document.createElement("meta");
      twitterCard.setAttribute("name", "twitter:card");
      twitterCard.setAttribute("content", "summary_large_image");
      document.head.appendChild(twitterCard);
    }

    let twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle) {
      twitterTitle.setAttribute("content", newTitle);
    } else {
      twitterTitle = document.createElement("meta");
      twitterTitle.setAttribute("name", "twitter:title");
      twitterTitle.setAttribute("content", newTitle);
      document.head.appendChild(twitterTitle);
    }

    let twitterDescription = document.querySelector('meta[name="twitter:description"]');
    if (twitterDescription) {
      twitterDescription.setAttribute("content", newDescription);
    } else {
      twitterDescription = document.createElement("meta");
      twitterDescription.setAttribute("name", "twitter:description");
      twitterDescription.setAttribute("content", newDescription);
      document.head.appendChild(twitterDescription);
    }

    // HREFLANG - For Canadian English
    let hreflang = document.querySelector('link[hreflang="en-ca"]');
    if (!hreflang) {
      hreflang = document.createElement("link");
      hreflang.setAttribute("rel", "alternate");
      hreflang.setAttribute("hreflang", "en-ca");
      hreflang.setAttribute("href", canonicalUrl);
      document.head.appendChild(hreflang);
    }

    // Robots meta tag
    let robotsTag = document.querySelector('meta[name="robots"]');
    if (robotsTag) {
      robotsTag.setAttribute("content", "index, follow, max-snippet:-1, max-image-preview:large");
    } else {
      robotsTag = document.createElement("meta");
      robotsTag.setAttribute("name", "robots");
      robotsTag.setAttribute("content", "index, follow, max-snippet:-1, max-image-preview:large");
      document.head.appendChild(robotsTag);
    }

  }, [location.pathname]);

  // Schema markup for North Vancouver page
  useEffect(() => {
  const schemaScript = document.createElement("script");
  schemaScript.setAttribute("type", "application/ld+json");
  schemaScript.setAttribute("data-schema", "northvancouver-landscaping");
  
  schemaScript.textContent = JSON.stringify({
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Landscaping and Garden Care North Vancouver",
    "serviceType": "Landscaping Services",
    "description": "Professional landscaping in North Vancouver since 1995. Offering lawn care, hardscape, softscape, design, snow management, and chafer beetle control.",
    "provider": {
      "@type": "LocalBusiness",
      "name": "BUR-HAN Garden & Lawn Care",
      "telephone": "+1-604-983-2687",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "2323 Old Dollarton Rd Unit A",
        "addressLocality": "North Vancouver",
        "addressRegion": "BC",
        "postalCode": "V7H 1A9",
        "addressCountry": "CA"
      }
    },
    "areaServed": {
      "@type": "City",
      "name": "North Vancouver"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "BUR-HAN North Vancouver Service Menu",
      "itemListElement": [
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Landscape Maintenance" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Residential Lawn Care" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Hardscape Installs/Maintenance" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Softscape Installs/Maintenance" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Designs and Modelling" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Snow Management" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "European Chafer Beetle Control" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Garden Cleanups" } }
      ]
    }
  });

  const existingSchema = document.querySelector('script[data-schema="northvancouver-landscaping"]');
  if (existingSchema) { existingSchema.remove(); }
  document.head.appendChild(schemaScript);
}, [location.pathname]);

  return (
    <div className="wrapper">
      <Header />
      <div className="serviceHeader">
        <h1>Landscaping North Vancouver </h1>
      </div>
      <div className="serviceMain" data-aos="fade-up">
        <p>
          <strong>
          Serving: Residential Lawn Care / Landscape Maintenance / Hardscape / Softscape / Design / Snow Management / European Chafer Beetle 
          </strong>
        </p>
        <hr />
        <p className="joinp">
          At BUR-HAN Garden and Lawn Care we put our clients first. Every
          individual of our highly skilled team truly cares about each property
          they set foot on. We know they do, because that’s part of the job
          requirements. Taking great care of our team translates to our
          customers receiving the best service in the industry.
        </p>
        {/* -------------- ABOUT -------------- */}
            <BhStory />
     
        {/* -------------- END OF ABOUT -------------- */}
        {/* -------------- QUOTELINE-------------*/}
        <section id="quoteLine" className="quoteLine">
          <div className="content">
            <h3>
              {" "}
              Whether you need routine maintenance, a complete overhaul, or
              anything in between, we're here to turn your dreams into reality.
            </h3>
            <a href="/contact-us" className="buttonQuoteLine">
              GET A QUOTE
            </a>
          </div>
        </section>
        {/* -------------- END OF QUOTELINE -------------*/}
        {/* --------------  SERVICES -------------- */}
        <section id="services" className="services section-bg">
          <h2 className="section-header" data-aos="fade-down">
            Our Services
          </h2>
          <p data-aos="zoom-in">
            "We offer excellent services, adapting to a wide range of
            preferences and requirements, ensuring your landscape achieves its
            utmost potential while simultaneously enhancing your property
            value."
          </p>
          <div className="row">
            <div
              className="col-lg-4 md-3 col-sm-6 col-xs-12"
              data-aos="fade-right"
            >
              <a href="/services/landscape-maintenance">
                <div className="servicesCard">
                  <div className="cover item-a">
                    <h3>Landscape Maintenance</h3>
                    <div className="card-back">
                      <ul>
                        <li>Full-Service Landscape Maintenance</li>
                        <li>Garden overhauls or one-time cleanups</li>
                        <li>Water bags for establishing trees</li>
                        <li>Tree staking</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </a>
            </div>
            <div
              className="col-lg-4 md-3 col-sm-6 col-xs-12"
              data-aos="fade-down"
            >
              <a href="/services/hardscape-installs-maintenance">
                <div className="servicesCard">
                  <div className="cover item-b">
                    <h3>Hardscape Installs/Maintenance</h3>
                    <div className="card-back">
                      <ul>
                        <li>Paver/slab patios and walkways</li>
                        <li>Modular block walls</li>
                        <li>
                          New Irrigation Installations with New Landscapes
                        </li>
                        <li>Grading and drainage solutions</li>
                        <li>Gravel/river rock installation</li>
                        <li>Excavation</li>
                        <li>Landscape lighting</li>
                        <li>Water features</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </a>
            </div>
            <div
              className="col-lg-4 md-3 col-sm-6 col-xs-12"
              data-aos="fade-left"
            >
              <a href="/services/design-and-modelling">
                <div className="servicesCard">
                  <div className="cover item-c">
                    <h3>Designs and Modelling</h3>
                    <div className="card-back">
                      <ul>
                        <li>Full Design</li>
                        <li>3D rendering</li>
                        <li>Irrigation/ Lightning</li>
                        <li>Basic Design Sketchers</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </a>
            </div>
            <div
              className="col-lg-4 md-3 col-sm-6 col-xs-12"
              data-aos="fade-right"
            >
              <a href="/services/residential-lawn-care">
                <div className="servicesCard">
                  <div className="cover item-d">
                    <h3>Residential Lawn Care</h3>
                    <div className="card-back">
                      <ul>
                        <li>Weekly lawn mowing/edging</li>
                        <li>Fertilizing</li>
                        <li>Liming</li>
                        <li>Aeration</li>
                        <li>Moss Control</li>
                        <li>Organic Weed Control Program</li>
                        <li>Topdressing</li>
                        <li>Overseeding</li>
                        <li>Chafer beetle mitigation</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </a>
            </div>
            <div
              className="col-lg-4 md-3 col-sm-6 col-xs-12"
              data-aos="fade-up"
            >
              <a href="/services/softscape-installs-maintenance">
                <div className="servicesCard">
                  <div className="cover item-e">
                    <h3> Softscape Installs/Maintenance</h3>
                    <div className="card-back">
                      <ul>
                        <li>Planting plans including design</li>
                        <li>Garden bed plantings </li>
                        <li>Lawn installation</li>
                        <li>Hedge installations</li>
                        <li>Soil and Mulch installations</li>
                        <li>
                          Garden bed dividers including Bender board, Precision
                          edge, landscape ties
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </a>
            </div>
            <div
              className="col-lg-4 md-3 col-sm-6 col-xs-12"
              data-aos="fade-left"
            >
              <a href="/services/snow-management">
                <div className="servicesCard">
                  <div className="cover item-f">
                    <h3>Snow Management</h3>
                    <div className="card-back">
                      <ul>
                        <li>Paving Stone Restoration</li>
                        <li>Paver Sealing </li>
                        <li>Paver and Slab Repair / Replacement</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </section>
        {/* -------------- END OF SERVICES -------------- */}
        {/* -------------- LAWN CARE SERVICES -------------- */}
        <section className="lawnCareLinks" data-aos="fade-up">
          <h2>Lawn Care Services in North Vancouver</h2>
          <div className="lawnCareLinks-grid">
            <a href="/lawn-mowing-north-vancouver">
              <strong>Lawn Mowing North Vancouver</strong>
              <span>Weekly electric mowing service</span>
            </a>
            <a href="/lawn-aeration-north-vancouver">
              <strong>Lawn Aeration North Vancouver</strong>
              <span>Core aeration for healthier roots</span>
            </a>
            <a href="/lawn-fertilizing-north-vancouver">
              <strong>Lawn Fertilizing North Vancouver</strong>
              <span>Seasonal fertilization programs</span>
            </a>
          </div>
        </section>
        {/* -------------- END OF LAWN CARE SERVICES -------------- */}
        {/* -------------- TESTIMONIALS --------------   */}
        <section className="service-area-about" data-aos="fade-up">
          <div className="container py-5 px-5">
            <h2>Landscaping & Lawn Care in North Vancouver</h2>
            <p>North Vancouver's combination of steep terrain, dense tree canopy, and one of BC's highest annual rainfall totals creates unique landscaping challenges. Lawns in Lynn Valley, Deep Cove, Lonsdale, and Pemberton Heights face year-round moss pressure, shade competition, and soil compaction from heavy rain. BUR-HAN has been managing North Shore properties for over 30 years — we understand the local conditions that affect your lawn and garden better than anyone.</p>
            <p>Our North Vancouver services include electric mowing on residential streets, precision aeration on hillside lots, and seasonal fertilization programs calibrated for North Vancouver's coastal climate. Every property is different — BUR-HAN tailors the approach to your specific lawn conditions, schedule, and goals.</p>
          </div>
        </section>
                <Testimonials />
        {/* -------------- END OF TESTIMONIALS -------------*/}
        {/* -----------------  AWARDS -----------------  */}
              <Awards />
               {/* -------------- END OF AWARDS -------------*/}
        {/* -------------- CONTACT --------------Í */}
        <HomeForm />
        {/* -------------- END OF CONTACT -------------*/}
      </div>
      <Footer />
    </div>
  );
}
